// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1558": "eb9dc10b","5336": "5083bc52","8942": "f06e52cc",}[chunkId] + ".css"
}